import React from 'react';
import ReactDOMServer from "react-dom/server";

const checkItems = [
  "One commitment you both share",
  "One plan to manage – no separate billing",
  "Up to 32% off for both of you",
];

const togetherConsistent = <div className="new-quote-container centered">
  <div className="splash-icon">🤝</div>
  <div className="splash-header">
    <h1 className="no-word-break">Train together.<br/>Stay consistent.</h1>
    <div className="quote">
      One subscription, two complete programs. Add someone to your plan and train together.
    </div>
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "400px",
      margin: "28px auto 0",
      padding: "0 36px",
    }}>
      {checkItems.map((item, idx) => (
        <div key={idx} style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontSize: "16px",
          color: "#1a1a1a",
          textAlign: "left",
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#E5EEFB",
            color: "#2F6FED",
            fontSize: "16px",
            fontWeight: 700,
            flexShrink: 0,
          }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#E7F0FF"/>
              <path d="M14.6665 6.50049L8.2498 12.9172L5.33313 10.0005" stroke="#0B6DFF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>{item}</span>
        </div>
      ))}
    </div>
  </div>
</div>;

const togetherConsistentElement = {
  name: 'togetherConsistent',
  type: 'html',
  html: ReactDOMServer.renderToStaticMarkup(togetherConsistent),
  defaultValue: "true",
}

export default togetherConsistentElement;
